/** @jsx jsx */
import { jsx } from "theme-ui";

const Layout = ({ children, styling }) => {
  return <div sx={{ ...styling, px: "5" }}>{children}</div>;
};

export default Layout;
